module.exports = __webpack_public_path__ + "static/media/python.6b6b072d.png";